import React, { useContext } from 'react';
import { Button, Card, Col, Row } from 'antd';
import './CardView.css';

import { isIPSAdministrator, isIPSDataCreatorOrAdministrator } from '../../utils/UserInfo';

import {
  getToolTipFormatedList,
  getToolTipFormatedStrForIPSDT,
} from '../Utils/String';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';

import IpsExlamationIcon from 'components/ExclamationIcon/IpsExlamationIcon';
import { tabNamesMap } from 'components/TabNamesMap';
import PhasedProjectComponent from './PhasedProjectComponent';

export default function IpsDataCardView(props) {
  const {
    project,
    onButtonClick,
    history,
    context,
    loading,
    handleDeleteBtnClick,
  } = props;

  const { dataTrackerPhaseDetails } = project || {};

  // for getting color of status
  const getStatusColor = {
    G: '#55b762',
    // Y: '#d2b16f',
    Y:'#e1ad01',
    R: '#d24448',
  };

  const getProjectHeaderColor = {
    // DT_C: '#bf9000',// old color
    DT_C: '#e1ad01',
    DT_P: '#ff9900',
    DT_N: '#D53326',
    DT_D: '#9fc5f8',
    DT_A: '#009e0f',
    DT_H:'#ffff00'
  };

  let getProjectLinkName = {
    DT_C: 'Go To Project',
    DT_P: 'Start Data Tracker',
    DT_N: 'Re-Activate',
    DT_D: 'Resolve Duplicate',
    DT_A: 'Go To Data Tracker',
    DT_H:'Go To Data Tracker'
  };

  function getActionsForStatus() {
    let actions = [];

    if (project.trackerStatus === 'DT_C' || project.trackerStatus === 'DT_A' || project.trackerStatus === 'DT_H') {
      actions.push(
        <>
          {project.manual && isIPSDataCreatorOrAdministrator() && (
            <Button
              id={'inDevCardEditLink'}
              className='dt-delete-btn'
              type={'link'}
              style={{ height: 'auto' }}
              onClick={() => handleDeleteBtnClick(project)}
            >
              Delete
            </Button>
          )}
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto' }}
            onClick={() => onButtonClick(project)}
          >
            {getProjectLinkName[project.trackerStatus]}
          </Button>
        </>
      );
      // https://jira.aepsc.com/browse/TCHEK-629
    } else if (
      project.trackerStatus === 'DT_P' ||
      project.trackerStatus === 'DT_D'

    ) {
      actions.push(
        !isIPSDataCreatorOrAdministrator() ? (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto', color: 'black' }}
            disabled={true}
          >
            Contact a Admin
          </Button>
        ) : (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto' }}
            onClick={() => onButtonClick(project)}
          >
            {getProjectLinkName[project.trackerStatus]}
          </Button>
        )
      );
    }else if (

      project.trackerStatus === 'DT_N'
    ) {
      actions.push(
        !isIPSAdministrator() ? (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto', color: 'black' }}
            disabled={true}
          >
            Contact a Admin
          </Button>
        ) : (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto' }}
            onClick={() => onButtonClick(project)}
          >
            {getProjectLinkName[project.trackerStatus]}
          </Button>
        )
      );
    }

    return actions;
  }

  function getCardTypeHeader() {
    let commonDesign = {
      minWidth: '120px',
      height: '70px',
      padding: '4px',
      fontSize: '16px',
      textAlign: 'center',
      color: '#fff',
    };

    return {
      backgroundColor: getProjectHeaderColor[project.trackerStatus],
      ...commonDesign,
    };
  }
 
  return (
    <Card
      title={
        <span style={{color:project.trackerStatus === 'DT_H'?'black':'white'}}>
          {project.stationName ? project.stationName : ' '}
          <br />{' '}
          {project.projectStatus &&
            ` CL: ${
              project.projectStatus !== null
                ? tabNamesMap[project.projectStatus]
                : ' '
            }`}
        </span>
      }
      id={'cardId' + project.bpid + project.stationName + project.workOrder}
      actions={getActionsForStatus()}
      headStyle={getCardTypeHeader()}
      bodyStyle={{
        fontSize: '12px',
        backgroundColor: '#ffffff',
        maxHeight: '31.5rem',
        minHeight: '31.5rem',
      }}
      style={{ marginBottom: '16px', boxShadow: '5px 5px 5px lightgrey' }}
      loading={loading}
    >
      <div>
        <b>Project Description</b>
        {project.trackerStatus !== 'DT_P' && (
          <IpsDTCommentsIcon
            project={project}
            commentGroup={'COMMON'}
            view={'dashboard'}
            comments={[]}
            phase={0}
          />
        )}
        {project.manual && <IpsExlamationIcon project={project} />}
        <br />
        <div>
          {project.projectDescription &&
            getToolTipFormatedList(project.projectDescription)}
        </div>
        {/* <br /> */}
        <hr />
        <div className='section-container'>
          <div className='date-section-container'>
            <b>Construction Start Date:</b>
          </div>
          <span>{project.constructionStartDate}</span>
        </div>
        {project.trackerStatus !== 'DT_P' &&<div className='section-container'>
          <div className='date-section-container'>
            <b>Checklist Release Date:</b>
          </div>
          <span>{project.tclReleaseDate}</span>
        </div>}
        <div className='section-container'>
          <div className='date-section-container'>
            <b>In-Service Date:</b>
          </div>
          <span>{project.inServiceDate}</span>
        </div>

        <hr />

        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className='section-container'>
              <div className='ids-section-container'>
                <b>WO:</b>
              </div>
              <span>
                {getToolTipFormatedStrForIPSDT('WO', project.workOrder, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container'>
                <b>BPID:</b>
              </div>
              <span>
                {getToolTipFormatedStrForIPSDT('BPID', project.bpid, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container'>
                <b>MPID:</b>
              </div>
              <span>
                {getToolTipFormatedStrForIPSDT('MPID', project.mpid, project)}
              </span>
            </div>
          </Col>
          <Col xs={21} sm={12} md={12} lg={12} xl={12}>
            <div className='section-container'>
              <div className='ids-section-container-right'>
                <b>CCA:</b>
              </div>
              <span>
                {project.ccaNames &&
                  getToolTipFormatedStrForIPSDT('CCA', project.ccaNames,project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container-right'>
                <b>RCA:</b>
              </div>
              <span>
                {project.rcaNames &&
                  getToolTipFormatedStrForIPSDT('RCA', project.rcaNames, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container-right'>
                <b>LCA:</b>
              </div>
              <span>
                {project.lcaNames &&
                  getToolTipFormatedStrForIPSDT('LCA', project.lcaNames, project)}
              </span>
            </div>
          </Col>
        </Row>

        <hr />
        <div className='section-container'>
          <div className='new-container'>
            <b>State:</b>
          </div>
          <span>{project.stationState}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>Station Region:</b>
          </div>
          <span>{project.stationRegion}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>TFS Station Area:</b>
          </div>
          <span>{project.tfStationArea}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>TFS P&C Area:</b>
          </div>
          <span>{project.pcArea}</span>
        </div>

        <hr />
        {project.trackerStatus !== 'DT_P' && (
          <>
            {dataTrackerPhaseDetails?.length === 1 ? (
              <>
                <div className='section-container'>
                  <div className='new-container'>
                    <b>Location Sheet Status:</b>
                  </div>
                  <span
                    style={{
                      color:
                        getStatusColor[dataTrackerPhaseDetails[0]?.locSheetDue],
                    }}
                  >
                    {dataTrackerPhaseDetails[0]?.locSheetStatus}
                  </span>
                </div>
                <div className='section-container'>
                  <div className='new-container'>
                    <b>SE Assets Status:</b>
                  </div>
                  <span
                    style={{
                      color:
                        getStatusColor[dataTrackerPhaseDetails[0]?.seAssetsDue],
                    }}
                  >
                    {dataTrackerPhaseDetails[0]?.seAssetsStatus}
                  </span>
                </div>

                <div className='section-container'>
                  <div className='new-container'>
                    <b>PCE Assets Status:</b>
                  </div>
                  <span
                    style={{
                      color:
                        getStatusColor[
                          dataTrackerPhaseDetails[0]?.pceAssetsDue
                        ],
                    }}
                  >
                    {dataTrackerPhaseDetails[0]?.pceAssetsStatus}
                  </span>
                </div>
                {/* <div className='section-container'>
                  <div className='new-container'>
                    <b>Assets Expected </b>
                  </div>
                  <span>{dataTrackerPhaseDetails[0]?.expectedAssetCnt}</span>
                </div> */}

                <div>
                  <b>Total No. of Assets Expected: </b>
                  <span>{dataTrackerPhaseDetails[0]?.expectedAssetCnt}</span>
                </div>
              </>
            ) : (
              <PhasedProjectComponent
                dataTrackerPhaseDetails={dataTrackerPhaseDetails}
                getStatusColor={getStatusColor}
              />
            )}
          </>
        )}
        <br />
       

        <div className='section-container'>
          <div className='new-container'>
            <b>Total No. of SE Assets:</b>
          </div>
          <span>{project.noOfSEAssets}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>Total No. of PCE Assets:</b>
          </div>
          <span>{project.noOfPCEAssets}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>Total No. of Assets:</b>
          </div>
          <span>{project.noOfAssets}</span>
        </div>
      </div>
    </Card>
  );
}